import { useFormController } from '@dreryk/react-common';
import { Form, StyledFlex } from '@dreryk/react-components';

import {
   CustomPatientGroupsFormBean,
   CustomPatientGroupsFormController,
   CustomPatientGroupsFormInitializer,
} from './CustomPatientGroupsForm.types';
import { CustomPatientGroupsName } from './fields/CustomPatientGroupsName';
import { CustomPatientGroupsColor } from './fields/CustomPatientGroupsColor';
import { useNotUniqueCustomPatientGroupNameErrorHandler } from './CustomPatientGroupsForm.hooks';

type CustomPatientGroupsFormRenderProps = Pick<CustomPatientGroupsFormController, 'handleSubmit' | 'formState'> & {
   setNotUniqueCustomPatientGroupNameError: VoidFunction;
};

type CustomPatientGroupsFormProps = {
   children: (renderProps: CustomPatientGroupsFormRenderProps) => JSX.Element;
   initializer?: CustomPatientGroupsFormInitializer;
};

export const CustomPatientGroupsForm = (props: CustomPatientGroupsFormProps): JSX.Element => {
   const { register, handleSubmit, formState, setError } = useFormController<CustomPatientGroupsFormBean>(
      props.initializer?.()
   );

   return (
      <Form noValidate autoComplete={false}>
         <StyledFlex gap={24} direction={'column'}>
            <CustomPatientGroupsName register={register} />
            <CustomPatientGroupsColor register={register} />
         </StyledFlex>

         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
            setNotUniqueCustomPatientGroupNameError: useNotUniqueCustomPatientGroupNameErrorHandler({
               setError: setError,
            }),
         })}
      </Form>
   );
};
